<div class="gbc-breadcrumb">
  <ol>
    @for (entry of entries; track entriesTrackByFn($index, entry)) {
      <li>
        @if (entry.last) {
          <span>{{entry.title | async}}</span>
        }
        @if (!entry.last) {
          <a [routerLink]="entry.link" [queryParams]="entry.queryParams">{{entry.title | async}}</a>
        }
      </li>
    }
  </ol>
</div>
